/** @format */

import Navbar from "../../../../shared/components/navbar";
import Footer from "../../../../shared/components/footer";
import PageContent from "../../../../shared/components/PageContent";
import useAppStateStore from "../../../../shared/store/AppStateStore";
import ReportClaimForm from "../../components/reportClaim/reportClaimForm";
import ClaimSectionCards from "../../components/reportClaim/ClaimSectionCards";
import ReportClaimFormIframe from "../../components/reportClaim/ReportClaimFormIframe";

const ReportClaimLayout = () => {
  const STATE = useAppStateStore();
  const insurer = STATE.customerPolicies?.customerPolicies?.[0]?.insurer;

  const isSpecialInsurer =
    insurer &&
    (insurer.toLowerCase().includes("ers") ||
      insurer.toLowerCase().includes("qbe") ||
      insurer.toLowerCase().includes("kgm") ||
      insurer.toLowerCase().includes("inshur"));

  return (
    <>
      <Navbar />
      <PageContent>
        {isSpecialInsurer ? (
          <ClaimSectionCards insurer={insurer} />
        ) : (
          <ReportClaimFormIframe />
        )}
      </PageContent>
      <Footer />
    </>
  );
};

export default ReportClaimLayout;
